var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"parent-container",staticStyle:{"height":"calc(90vh - 65px)","background-color":"#f8f9fb","padding":"0","margin":"0"},attrs:{"id":"contrato","fluid":"","tag":"section"}},[_c('div',[_c('img',{staticStyle:{"max-width":"300px"},attrs:{"src":require("../../assets/lg_grupo.png"),"width":"80%"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }